module.exports = __webpack_public_path__ + "media/2.e327200c.mp3";